import React from 'react';
import classnames from 'classnames';
import styles from './styles.scss';
import { Conditional } from 'common/components/layout';

export default function Toggle({
    className,
    name,
    label,
    onChange,
    defaultChecked
}) {
    return (
        <div className={classnames(className, styles.toggleWrapper)} data-cy="Toggle">
            <input
                type='checkbox'
                className={styles.toggle}
                name={name}
                onChange={onChange}
                defaultChecked={defaultChecked}
                data-cy="Toggle-checkbox"
            />
            <Conditional condition={label}>
                <label className={styles.toggleLabel} htmlFor={name} data-cy="Toggle-label">
                    {label}
                </label>
            </Conditional>
        </div>
    );
}
